import React from "react"

import {FORMAT_TEXT_COMMAND} from "lexical"
import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"
import {lexicalClearFormatting} from "../../../../actions/clear-formatting"

export default function ToolbarStylesMenu(props:any) {

    const onClickUnderline = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')
    }

    const onClickStrikethrough = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')
    }

    const onClickSubscript = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'subscript')
    }

    const onClickSuperscript = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'superscript')
    }

    const onClickCode = () => {
        props.hidePopover()
        props.menuParams.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'code')
    }

    const onClickClearFormatting = () => {
        props.hidePopover()
        lexicalClearFormatting(props.menuParams.editor)
    }

    return (
        <div className="ui5-popover-menu" style={{minWidth:180}}>
            <PopoverMenuOption option   = {{icon: 'editor-i5-underline fs-16', label: 'Underline'}}
                               selected = {props.menuParams.isUnderline}
                               onClick  = {onClickUnderline}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-strikethrough fs-16', label: 'Strikethrough'}}
                               selected = {props.menuParams.isStrikethrough}
                               onClick  = {onClickStrikethrough}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-subscript fs-16', label: 'Subscript'}}
                               selected = {props.menuParams.isSubscript}
                               onClick  = {onClickSubscript}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-superscript fs-16', label: 'Superscript'}}
                               selected = {props.menuParams.isSuperscript}
                               onClick  = {onClickSuperscript}/>

            <PopoverMenuOption option   = {{icon: 'editor-i5-code fs-16', label: 'Inline code'}}
                               selected = {props.menuParams.isCode}
                               onClick  = {onClickCode}/>

            <div className="separator"/>

            <PopoverMenuOption option   = {{icon: 'i5-none', label: 'Clear Formatting'}}
                               onClick  = {onClickClearFormatting}/>
        </div>
    )
}